import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const I_CONNECTION_AVAILABILITY_SERVICE = new InjectionToken<IConnectionAvailabilityService>('IConnectionAvailabilityService');
export interface IConnectionAvailabilityService {
  isConnectionAvailable: Observable<boolean>;
}
